<div class="equip-config" [ngClass]="(!equipDeleted ? (checkEquipConfigIsSensorOrBuildingOrHeatExchanger ?  data.isEquipConnected ? 'sensorModelHeightwithNote' :  'sensorModel': data.isEquipConnected ? 'equipHeightwithNote': 'equipModel'): 'equipDeleted') ">

  @if (data.childData?.equipData?.displayName) {
    <div class="equipHeaderText notranslate">{{addTooltip(data.childData.equipData.displayName)}} Config</div>
  }

  <div class="row m-t-16" [ngClass]="checkEquipConfigIsSensorOrBuildingOrHeatExchanger ? 'p-l-15': ''">
    @if (data.childData?.equipData?.displayName) {
      <div [ngClass]="checkEquipConfigIsSensorOrBuildingOrHeatExchanger ? 'col-12': 'col-4'">
        <div class="labelText">
          Equip Name
        </div>
        <div matTooltip="{{data.childData.equipData.displayName}}"
        matTooltipPosition='above' class="equipNameForm notranslate">{{data.childData.equipData.displayName}}</div>
      </div>
    }
    @if (!checkEquipConfigIsSensorOrBuildingOrHeatExchanger) {
      <div class="col-4">
        <div class="labelText">
          Brand
        </div>
        <div class="equipNameForm">{{data.childData.equipData.brand != undefined?data.childData.equipData.brand:"-"}}</div>
      </div>
    }
    @if (!checkEquipConfigIsSensorOrBuildingOrHeatExchanger) {
      <div class="col-4">
        <div class="labelText">
          Model
        </div>
        <div class="equipNameForm">{{data.childData.equipData.model != undefined?data.childData.equipData.model:"-"}}</div>
      </div>
    }
  </div>
  @if (!checkEquipConfigIsSensorOrBuildingOrHeatExchanger) {
    <div  class="row m-t-10">
      <div class="col-4">
        <div class="labelText">
          Capacity
        </div>
        <div class="equipNameForm">{{data.childData.equipData.capacity != undefined?data.childData.equipData.capacity:"-"}}</div>
      </div>
      @if (data.childData?.equipData?.maxMaxFrequency) {
        <div class="col-4">
          <div class="labelText">
            Max VFD Frequency
          </div>
          <div class="equipNameForm">{{data.childData.equipData.maxMaxFrequency != undefined?data.childData.equipData.maxMaxFrequency:"-"}}</div>
        </div>
      }
    </div>
  }

  @if (showNote) {
    <div class="row m-t-2 m-b-10 note-text" >
      <div class="col-12">
      Please note: you will not be able to reposition sensor devices on the pipe as parent equip is already connected to other equip/s, please remove all connections to reposition the sensor device        </div>
    </div>
  }

  <div class="row pointsHeader">
    <div class="p-lr-0" [ngClass]="isSensorNode ? 'col-8': 'col-6'">
      <div class="d-flex">
        <div class="w-100 ">Points</div>
        <div class="flex-shrink-1 verticalLine">|</div>
      </div>
    </div>

    <div class="p-lr-0" [ngClass]="isSensorNode ? 'col-4': 'col-2'">
      <div class="d-flex">
        <div class="w-100 ">Master <i  matTooltip="Point Limit: {{pointLimit}}" matTooltipPosition="above"   matTooltipClass="mastertooltip" class="fa-solid fa-circle-info infoIcon"></i></div>
        @if (!checkEquipConfigIsSensorOrBuildingOrHeatExchanger) {
          <div class="flex-shrink-1 verticalLine">|</div>
        }
      </div>
    </div>

    @if (!checkEquipConfigIsSensorOrBuildingOrHeatExchanger) {
      <div class="col-2 p-lr-0">
        <div class="d-flex">
          <div class="w-100 ">Hover</div>
          <div class="flex-shrink-1 verticalLine">|</div>
        </div>
      </div>
    }
    @if (!checkEquipConfigIsSensorOrBuildingOrHeatExchanger) {
      <div class="col-2 p-lr-0">
        <div>Click</div>
      </div>
    }
  </div>

  @if (isLoading) {
    <div class="ngxLoader">
      <ngx-skeleton-loader [theme]="{height: '20px', 'background-color': '#eff0f1'}" count="10"></ngx-skeleton-loader>
    </div>
  }

  @if (!isLoading) {
    <div cdkDropList class="tableContainer" [ngClass]="{equipDeleted: 'equipDeleted'}" (cdkDropListDropped)="equipPrimaryPoint($event)">
      @if (!equipDeleted) {
        @for (point of equipList.parentEquip.points; track point) {
          <div class="row pointRowStyle"  [ngClass]="{'pointRow':!data.isEquipConnected && isSensorNode}" cdkDrag [cdkDragDisabled]="!isSensorNode || data.isEquipConnected">
            <div class="pointText" [ngClass]="isSensorNode ? 'col-8': 'col-6'">
              @if (!data.isEquipConnected && isSensorNode) {
                <i [ngClass]="data.isEquipConnected ? 'grey-color': 'primary-color'"   class="fas fa-grip-vertical p-r-5" aria-hidden="true"></i>
                } <span class="notranslate">{{point.pointName}}</span>
              </div>
              <div class="textCenter p-5-0" [ngClass]="isSensorNode ? 'col-4': 'col-2'">
                @if (data.isEquipConnected && isSensorNode && !(data.childData.class.includes('btuMeter'))) {
                  <span class="disableToolTip" matTooltip="remove all the connections to add/remove the sensor device" matTooltipPosition="above" matTooltipClass="disableMastertooltip">
                    <mat-checkbox [disabled]="true" [checked]="point.master" [(ngModel)]="point.master"
                    [ngModelOptions]="{standalone: true}"></mat-checkbox>
                  </span>
                }
                @if (!isSensorNode || (isSensorNode && !data.isEquipConnected) || data.childData.class.includes('btuMeter')) {
                  <span >
                    <mat-checkbox [disabled]="checkMasterDisable(point)" [checked]="point.master" [(ngModel)]="point.master"
                    [ngModelOptions]="{standalone: true}"></mat-checkbox>
                  </span>
                }
              </div>
              @if (!checkEquipConfigIsSensorOrBuildingOrHeatExchanger) {
                <div class="col-2 textCenter p-5-0">
                  <mat-checkbox [checked]="point.hover" [(ngModel)]="point.hover"
                  [ngModelOptions]="{standalone: true}"></mat-checkbox>
                </div>
              }
              @if (!checkEquipConfigIsSensorOrBuildingOrHeatExchanger) {
                <div class="col-2 textCenter  p-5-0">
                  <mat-checkbox [disabled]="checkClickDisable(point)" [checked]="point.click" [(ngModel)]="point.click"
                  [ngModelOptions]="{standalone: true}"></mat-checkbox>
                </div>
              }
            </div>
          }
          <br/>
          @if (!isHeaderPipe(equipList.parentEquip.class) && !isBypassPipe(equipList.parentEquip.class)) {
            <div>
              @for (subEquipData of equipList.childEquip; track subEquipData) {
                <div>
                  <div class="row col-10 pointsHeaderText">
                    <span class="notranslate">{{ subEquipData.name }}</span>
                  </div>
                  <div cdkDropList (cdkDropListDropped)="dropSubEquip($event,subEquipData)">
                    @for (subEquip of subEquipData.points; track subEquip) {
                      <div class="row pointRowStyle"  [ngClass]="{'pointRow':!data.isEquipConnected}" cdkDrag [cdkDragDisabled]="data.isEquipConnected">
                        <div class="pointText col-6">
                          <i [ngClass]="data.isEquipConnected ? 'grey-color': 'primary-color'"   class="fas fa-grip-vertical p-r-5" aria-hidden="true"></i> <span class="notranslate">{{ subEquip.pointName }}</span>
                        </div>
                        <div class="textCenter p-5-0" [ngClass]="isSensorNode ? 'col-4': 'col-2'">
                          @if (data.isEquipConnected) {
                            <span class="disableToolTip" matTooltip="remove all the connections to add/remove the sensor device" matTooltipPosition="above" matTooltipClass="disableMastertooltip">
                              <mat-checkbox [disabled]="checkChildMasterDisable(subEquip)" [checked]="subEquip.master"
                              [(ngModel)]="subEquip.master" [ngModelOptions]="{standalone: true}"></mat-checkbox>
                            </span>
                          }
                          @if (!data.isEquipConnected) {
                            <span>
                              <mat-checkbox [disabled]="checkChildMasterDisable(subEquip)" [checked]="subEquip.master"
                              [(ngModel)]="subEquip.master" [ngModelOptions]="{standalone: true}"></mat-checkbox>
                            </span>
                          }
                        </div>
                        @if (!checkEquipConfigIsSensorOrBuildingOrHeatExchanger) {
                          <div class="col-2 textCenter p-5-0">
                            <mat-checkbox [checked]="subEquip.hover" [(ngModel)]="subEquip.hover"
                            [ngModelOptions]="{standalone: true}"></mat-checkbox>
                          </div>
                        }
                        @if (!checkEquipConfigIsSensorOrBuildingOrHeatExchanger) {
                          <div class="col-2 textCenter  p-5-0">
                            <mat-checkbox [disabled]="checkClickDisable(subEquip)" [checked]="subEquip.click" [(ngModel)]="subEquip.click"
                            [ngModelOptions]="{standalone: true}"></mat-checkbox>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
          @if (!equipDeleted && !isHeaderPipe(data.childData.class) && !isBypassPipe(equipList.parentEquip.class) && (!checkEquipConfigIsSensorOrBuildingOrHeatExchanger || isSensorNode)) {
            <div class="row p-t-10">
              <div class="col-6 pointsHeaderText">
                Custom Points
              </div>
              <div class="col-6">
                <i (click)="addPointModel()" class="fa-solid fa-plus addIcon"></i>
              </div>
            </div>
          }
          @for (custompoint of customPointList; track custompoint) {
            <div class="row pointRowStyle">
              <div class="pointText" [ngClass]="isSensorNode ? 'col-6': 'col-5'">
                <span class="notranslate">{{custompoint.pointName}}</span>
              </div>
              <div class="p-5-0 textAlignRight" [ngClass]="isSensorNode ? 'col-2': 'col-1'">
                <i (click)="deleteCustomPoint(custompoint)" class="fa-solid fa-trash deleteIcon"></i>
              </div>
              <div class="textCenter p-5-0" [ngClass]="isSensorNode ? 'col-4': 'col-2'">
                <mat-checkbox [disabled]="checkMasterDisable(custompoint)" [(ngModel)]="custompoint.master"
                [checked]="custompoint.master" [ngModelOptions]="{standalone: true}"></mat-checkbox>
              </div>
              @if (!isSensorNode) {
                <div class="col-2 textCenter  p-5-0">
                  <mat-checkbox [(ngModel)]="custompoint.hover" [checked]="custompoint.hover"
                  [ngModelOptions]="{standalone: true}"></mat-checkbox>
                </div>
              }
              @if (!isSensorNode) {
                <div class="col-2 textCenter  p-5-0">
                  <mat-checkbox  [(ngModel)]="custompoint.click" [checked]="custompoint.click"
                  [ngModelOptions]="{standalone: true}"></mat-checkbox>
                </div>
              }
            </div>
          }
          @if (!equipDeleted && !isSensorNode && !checkEquipConfigIsSensorOrBuildingOrHeatExchanger) {
            <div class="row p-t-10">
              <div class="col-6 pointsHeaderText">
                Custom Alerts
              </div>
              <div class="col-6">
                <i (click)="addAlertModel()" class="fa-solid fa-plus addIcon"></i>
              </div>
            </div>
          }
          @for (alert of alertList; track alert) {
            <div class="row">
              <div class="col-6 pointText">
                {{alert.alertName}}
              </div>
              <div class="col-6">
                <i (click)="deleteAlertClicked(alert)" class="fa-solid fa-trash deleteIcon"></i>
              </div>
            </div>
          }
        }
        @if (equipDeleted) {
          <div class="equipDeletedClass">
            The Equipment has been deleted.
          </div>
        }
      </div>
    }

    <div class="flex-footer  d-flex justify-content-end p-t-18">
      @if (!equipDeleted) {
        <div class="col-4">
          <button (click)="deleteEquip()" class="text-uppercase btn color-primary text-uppercase">DELETE EQUIP</button>
        </div>
      }
      <div class="col-8 d-flex justify-content-end align-items-center">
        <button (click)="cancel()" class="text-uppercase btn color-primary text-uppercase">CANCEL</button>
        <span class="separatorIcon">|</span>
        @if (!equipDeleted) {
          <button (click)="saveConfig()" class="text-uppercase btn color-primary text-uppercase" [ngClass]="saveButtonDisable ? 'disable': ''" [disabled]="saveButtonDisable" >SAVE CONFIG</button>
        }
        @if (equipDeleted) {
          <button (click)="deleteEquip()" class="text-uppercase btn color-primary text-uppercase" [ngClass]="saveButtonDisable ? 'disable': ''" [disabled]="saveButtonDisable" >REMOVE EQUIP FROM CANVAS</button>
        }
      </div>
    </div>
  </div>